import React from 'react'

import { useTranslation } from 'react-i18next'

interface DiscoverMoreButtonProps {
    className?: string
    link: string
}

export const DiscoverMoreButton: React.FC<DiscoverMoreButtonProps> = ({ className, link }) => {
    const { t } = useTranslation()
    return (
        <a
            href={link}
            className={`bg-blue-500 text-white inline-block py-2 px-4 text-center rounded ${className} min-h-9 max-w-[300px] sm:max-w-[200px]`}
            rel="noopener noreferrer">
            {t('common.more')}
        </a>
    )
}
